"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./_internal/utils");
var map_1 = tslib_1.__importDefault(require("./Lazy/map"));
var reject_1 = tslib_1.__importDefault(require("./Lazy/reject"));
var toAsync_1 = tslib_1.__importDefault(require("./Lazy/toAsync"));
var zip_1 = tslib_1.__importDefault(require("./Lazy/zip"));
var pipe_1 = tslib_1.__importDefault(require("./pipe"));
var toArray_1 = tslib_1.__importDefault(require("./toArray"));
function omitBy(f, obj) {
    if (obj === undefined) {
        return function (obj) { return omitBy(f, obj); };
    }
    var entries = Object.entries(obj);
    var conditions = entries.map(function (entry) { return f(entry); });
    var isAsync = conditions.some(function (c) { return (0, utils_1.isPromise)(c); });
    if (isAsync) {
        return (0, pipe_1.default)(entries, (0, zip_1.default)((0, toAsync_1.default)(conditions)), (0, reject_1.default)(function (_a) {
            var _b = tslib_1.__read(_a, 1), cond = _b[0];
            return cond;
        }), (0, map_1.default)(function (_a) {
            var _b = tslib_1.__read(_a, 2), entry = _b[1];
            return entry;
        }), toArray_1.default, Object.fromEntries);
    }
    else {
        return (0, pipe_1.default)(entries, (0, zip_1.default)(conditions), (0, reject_1.default)(function (_a) {
            var _b = tslib_1.__read(_a, 1), cond = _b[0];
            return cond;
        }), (0, map_1.default)(function (_a) {
            var _b = tslib_1.__read(_a, 2), entry = _b[1];
            return entry;
        }), Object.fromEntries);
    }
}
exports.default = omitBy;
//# sourceMappingURL=omitBy.js.map